import axios from 'axios';
import cookieLocalStorage from '../helpers/dataStorage';

var qs = require('qs');

const client_id = '6hr6iiqnsv5r748dhokno48o8d';
const aws_domain = 'appstats.auth.us-east-1.amazoncognito.com';

let API_aws = axios.create({
    baseURL: `https://${aws_domain}`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
});

API_aws.interceptors.response.use(null, function (error) {
    const response = error.response;
    console.log(response);

    if (response.status === 400 && response.data.error == 'invalid_grant') {
        clearTokens();
        return Promise.resolve(validateTokens(''));
    } else {
        return Promise.reject(error);
    }
});

let clearTokens = function () {
    cookieLocalStorage.remove('access_token');
    cookieLocalStorage.remove('refresh_token');
};

let storeToken = function (token, tokenName, expires) {
    cookieLocalStorage.set(tokenName, token, expires);
};

let hasRefreshToken = function () {
    let token = cookieLocalStorage.get('refresh_token');
    if (token === null) {
        return false;
    }

    return true;
};

let validateTokens = function (URIToReturn) {
    console.log('validateTokens');
    // console.log(URIToReturn);
    // debugger;
    if (URIToReturn !== '') {
        localStorage.lastPath = URIToReturn;
    }

    if (!hasRefreshToken()) {
        return getAuthCode();
    }

    return refreshIDToken();
};
let getNewTokens = function () {
    var params = {
        grant_type: 'authorization_code',
        client_id: client_id,
        code: localStorage.code,
        redirect_uri: window.location.protocol + '//' + window.location.host + '/signedin',
        scope: 'email',
        // code_verifier: verifier,
    };

    return API_aws.post('/oauth2/token', qs.stringify(params))
        .then(resp => {
            var idToken = resp.data.access_token;
            var refreshToken = resp.data.refresh_token;
            storeToken(idToken, 'access_token', '60m');
            storeToken(refreshToken, 'refresh_token', '30D');
        });
};

let logout = function () {
    const redirect_uri = window.location.protocol + '//' + window.location.host + '/signedin';
    const state = localStorage.code;
    const url = `https://${aws_domain}/logout?response_type=code&client_id=${client_id}&redirect_uri=${redirect_uri}&state=${state}&scope=openid+profile`;
    clearTokens();
    window.open(url, '_self');
};

let refreshIDToken = function () {
    var params = {
        grant_type: 'refresh_token',
        client_id: client_id,
        refresh_token: cookieLocalStorage.get('refresh_token'),
    };

    return API_aws.post('/oauth2/token', qs.stringify(params))
        .then(resp => {
            var idToken = resp.data.access_token;
            storeToken(idToken, 'access_token', '60m');
        });
};
let getAuthCode = function () {
    var clientId = client_id;
    var domain = aws_domain;
    var type = 'code';
    var scope = 'openid profile email demo/test';
    var callback = window.location.protocol + '//' + window.location.host + '/signedin';
    // var method = "S256"
    // var code_verifier = generateCodeVerifier(128)
    // var code_challenge = generateCodeChallenge(code_verifier)
    // localStorage.verifier = code_verifier

    let redirectTo = 'https://' + domain + '/authorize?response_type=' + type +
        '&client_id=' + clientId + '&redirect_uri=' + callback + '&scope=' + scope +
        '&promt=none' + '&response_mode=web_message';

    // let redirectTo = 'https://' + domain + '/authorize?response_type=' + type
    // + '&client_id=' + clientId + '&redirect_uri=' + callback + '&scope=' + scope +
    // '&promt=none' + '&response_mode=web_message' + '&code_challenge=' + code_challenge +
    // '&code_challenge_method=' + method
    window.location.href = redirectTo;
};

export default {
    validateTokens,
    getNewTokens,
    logout,
};
